import { useState } from "react";

import { useTranslation } from "react-i18next";

import OptionalTooltip from "@/components/Tooltip/OptionalTooltip";

import { TableRowData, useMediaQueries } from "../../../shared";
import Button, {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS
} from "../Button";

interface IInlineActionIconButtonProps {
  title: string;
  icon: React.JSX.Element;
  customId?: string;
  rowData?: TableRowData;
  hasLoader?: boolean;
  isEnabled?: boolean;
  isDetails?: boolean;
  clickAction?: (
    currentRowData?: TableRowData,
    setIsButtonLoading?: any
  ) => Promise<void> | void;
}

const InlineActionIconButton = ({
  title,
  icon,
  hasLoader,
  customId,
  rowData,
  isEnabled = true,
  isDetails,
  clickAction
}: IInlineActionIconButtonProps) => {
  const { t } = useTranslation();

  const { toMd } = useMediaQueries();

  const [inlineBtnLoading, setInlineBtnLoading] = useState(false);

  const handleClick = async () => {
    await clickAction?.(rowData, setInlineBtnLoading);
  };

  return (
    <OptionalTooltip
      isDisabled={!isEnabled}
      tooltipTitle={isDetails ? title : t(`Button##inline actions##${title}`)}
      tooltipPlacement="top"
      disableInteractive
      disableTouchListener
    >
      <Button
        data-testid={customId ?? `${title.toLowerCase()}-button`}
        id={customId ?? `${title.toLowerCase()}-button`}
        disabled={!isEnabled}
        fullWidth={toMd}
        color={BUTTON_COLORS.PrimarySubtle}
        size={BUTTON_SIZES.Small}
        variant={toMd ? BUTTON_VARIANTS.TextOnly : BUTTON_VARIANTS.IconOnly}
        icon={icon}
        onClick={handleClick}
        isLoading={hasLoader && inlineBtnLoading}
      >
        {toMd && icon}
      </Button>
    </OptionalTooltip>
  );
};

export default InlineActionIconButton;
